import { jsx as _jsx } from "react/jsx-runtime";
import LogoViamidia from "@svgs/logoViamidia.svg";
import * as styles from "./logo.module.css";
const Logo = () => {
    return (_jsx("div", { className: styles.logo, children: _jsx("a", { href: "/", children: _jsx(LogoViamidia, {}) }) }));
};
export default Logo;
